export default {
  app: {
    languagePopup: {
      title: 'Jelenleg a {logo} angol nyelvű változatát használja',
      subtitle: 'Szeretne átváltani a kívánt nyelvre?',
      cta: 'Váltás erre: {lang}',
    },
  },
};
